import { findWithRegex } from "../common";

//「@nickname:rid」  -> ex) 「@HOTGE_더쿠:2488」의 형식으로 처리
// export const MENTION_REGEX = /「@[\s\wㄱ-ㅎ|가-힣|a-z|A-Z|0-9|:|]+」/g;
export const MENTION_REGEX = /「@[^」]+[:]\d+」/g;
// export const MENTION_REGEX = /「@[\W\w|^「|^」]+:[0-9]+」/g;
export function mentionStrategy(contentBlock, callback, contentState) {
    findWithRegex(MENTION_REGEX, contentBlock, callback);
}
